import { ChevronLeft } from "@mui/icons-material";
import {
  Box,
  IconButton,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
// import { GetData } from "contexts/DataContext";
import { isObjectEmpty, parentDirectory } from "data/functions";
import { routerStruct } from "data/routes";
import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const PageTitle = (props) => {
  const mobile = useMediaQuery(useTheme()?.breakpoints.down("tablet"));
  const navigate = useNavigate();
  // const { dataObj } = GetData();
  const ref = React.useRef(null);
  const ref2 = React.useRef(null);
  React.useEffect(() => {
    let notEmpty = !!ref.current?.value;
    if (notEmpty) ref.current.blur();
    notEmpty = !!ref2.current?.value;
    if (notEmpty) ref2.current.blur();
  }, [ref.current, ref2.current]);

  const tWidth =
    !props?.fButton && !props?.sButton ? "calc(100% - 32px)" : "70%";
  const fWidth = !props?.fButton ? "0%" : !props?.sButton ? "24%" : "12%";
  const sWidth = !props?.sButton ? "0%" : !props?.fButton ? "24%" : "12%";

  return (
    <React.Fragment>
      {/* <Paper
        sx={{
          boxShadow: "none",
          display: props.display ? props.display : undefined,
          // minHeight: "50px",
          padding: mobile ? "0.4rem 0" : undefined,
          position: "relative",
          caretColor: "transparent",
          userSelect: "none",
        }}
      > */}
      <Box
        ref={ref}
        sx={{
          alignItems: "center",
          caretColor: "transparent",
          display: "flex",
          flexDirection: "row",
          flexWrap: "nowrap",
          gap: "4px",
          padding: "4px 4px 12px 4px",
          userSelect: "none",
          width: "100%",
        }}
      >
        <Box sx={{ flexBasis: "32px", maxWidth: "32px" }}>
          <IconButton
            // color={"w"}
            disableRipple
            onClick={() => {
              // let nav = window.location.pathname.substring(
              //   0,
              //   window.location.pathname.lastIndexOf("/"),
              // );
              // if (!nav) nav = "/";
              navigate(parentDirectory(window.location.pathname));
            }}
            sx={{
              // bottom: 0,
              maxWidth: "100%",
              padding: 0,
              // position: "absolute",
              // top: 0,
              // width: { mobile: "40px", tablet: "40px" },
            }}
            variant="outlined"
          >
            <ChevronLeft
              sx={{ height: "1.2rem", opacity: 1, width: "1.2em" }}
            />
          </IconButton>
        </Box>
        <Box sx={{ flexBasis: tWidth, maxWidth: tWidth }}>
          <Box
            sx={{
              alignContent: "center",
              // flexWrap: "wrap",
              alignItems:
                mobile && !props?.alignStart ? "center" : "flex-start",
              display: "flex",
              flexDirection: mobile ? "column" : "row",
              gridGap: !mobile ? "12px" : undefined,
              justifyContent: mobile ? "center" : "flex-start",
              minHeight: "inherit",
              padding: mobile ? "0" : "1rem",
              width: "100%",
            }}
          >
            <Typography
              ref={ref2}
              sx={{
                textAlign: mobile ? "center" : "start",
              }}
              variant={mobile ? "h5" : "h4"}
            >
              {!isObjectEmpty(props.title) ? props.title : ""}
            </Typography>
            <Typography
              sx={{
                textAlign: "center",
              }}
              variant={mobile ? "h5" : "h4"}
            >
              {!isObjectEmpty(props.title2) ? props.title2 : ""}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ flexBasis: fWidth, maxWidth: fWidth }}>
          {props?.fButton ? props?.fButton : ""}
        </Box>
        <Box sx={{ flexBasis: sWidth, maxWidth: sWidth }}>
          {props?.sButton ? props?.sButton : ""}
        </Box>
      </Box>

      {/* <IconButton
          // color={"w"}
          disableRipple
          onClick={() => {
            let currentUrl = window.location.href;
            props?.home ? navigate("/") : navigate(-1);
            setTimeout(function () {
              // if location was not changed in 100 ms, then there is no history back
              if (currentUrl === window.location.href) {
                // redirect to site root
                navigate("/");
              }
            }, 150);
          }}
          sx={{
            bottom: 0,
            padding: 0,
            position: "absolute",
            top: 0,
            width: { mobile: "40px", tablet: "40px" },
          }}
          variant="outlined"
        >
          <ChevronLeft sx={{ height: "1.2rem", opacity: 1, width: "1.2em" }} />
        </IconButton> */}
      {/* </Paper> */}
    </React.Fragment>
  );
};
